
export class TicketsConstants {

  public static readonly COMMENT_FETCH_SIZE = 20;
  public static readonly CHANGE_HISTORY_FETCH_SIZE = TicketsConstants.COMMENT_FETCH_SIZE;

}
